var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',{staticClass:"mx-2"},[_c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [(_vm.description)?_c('p',_vm._g({},tooltip),[_vm._v(" "+_vm._s(_vm.description.text))]):_c('p',_vm._g({},tooltip),[_vm._v(" "+_vm._s(_vm.$t('review.reviewCard.noDescription')))])]}}])},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('review.reviewCard.tooltip.description')))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3810b4c7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/review/ReviewInfoAlternative.vue
// module id = null
// module chunks = 